import { useFileDownload } from "../components/Common/useFileDownload";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { ProductConfigurationReportParams, formatProductConfigurationReportQuery } from "./useGetProductConfigurationReport";

export interface DownloadProductConfigurationReportParams extends ProductConfigurationReportParams {
  siteName?: string;
  productName?: string;
}

export const useDownloadProductConfigurationReport = (params: DownloadProductConfigurationReportParams) => {
  const business = useSelectedBusiness();
  const localDateString = new Date().toLocaleString().split(',')[0].replaceAll('/', '-');

  var filename = 'productConfigurationReport';
  if (params.siteId) filename += `_${params.siteName}`;
  if (params.productId) filename += `_${params.productName}`;
  filename = filename + `_${localDateString}.csv`;

  return useFileDownload(formatProductConfigurationReportQuery(business.id, params, true), filename);
}